import { render } from "./WorkerInfoForm.vue?vue&type=template&id=70d225a7&scoped=true"
import script from "./WorkerInfoForm.vue?vue&type=script&lang=js"
export * from "./WorkerInfoForm.vue?vue&type=script&lang=js"

import "./WorkerInfoForm.vue?vue&type=style&index=0&id=70d225a7&lang=scss"
import "./WorkerInfoForm.vue?vue&type=style&index=1&id=70d225a7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d225a7"]])

export default __exports__